import * as types from '../types.js';

/**
 * Modal — Relatório de derrubadas (ondas).
 * Formatos: Tela (JSON), PDF, CSV. Modelo: Controle de movimentações.
 */
export default {

	html: `
		<style>
			#picking-waves-report-form #company_id { width: 15rem; }
			#picking-waves-report-form #date_from,
			#picking-waves-report-form #date_to { width: 10rem; }
			#picking-waves-report-form #wave_id { width: 8rem; }
			#picking-waves-report-form .pwr-legend { font-size: 0.85rem; color: var(--color-muted); line-height: 1.45; }
		</style>
		<form id="picking-waves-report-form" class="form" autocomplete="off">
			<datalist id="pwr-companies"></datalist>
			<div class="title">Relatório de derrubadas</div>
			<p class="mts pwr-legend">
				<strong>Por onda:</strong> andamento Descer e evolução das saídas.<br>
				<strong>Tarefas Descer:</strong> origem → destino, SKU/lote e status da tarefa.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="pwr-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup> <span class="fss">(criação da onda)</span>
					<input id="date_from" type="date" required>
				</label>
				<label>Até<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>Visão
					<select id="view">
						<option value="waves" selected>Por onda</option>
						<option value="tasks">Tarefas Descer</option>
					</select>
				</label>
				<label>Nº onda (opcional)
					<input id="wave_id" type="number" min="1" step="1" placeholder="todas">
				</label>
				<label>Status (opcional)
					<select id="status">
						<option value="">Todos</option>
						<optgroup label="Status da onda (visão Por onda)">
							<option value="CONFIRMED">Confirmada</option>
							<option value="DESCENDING">Descendo</option>
							<option value="PICKING">Separação</option>
							<option value="DONE">Concluída</option>
							<option value="EXCEPTION">Exceção</option>
							<option value="CANCELLED">Cancelada</option>
						</optgroup>
						<optgroup label="Status da tarefa (visão Tarefas Descer)">
							<option value="PENDING">Pendente</option>
							<option value="IN_PROGRESS">Em andamento</option>
							<option value="DIVERGENCE">Divergência</option>
						</optgroup>
					</select>
				</label>
			</div>
			<div class="mtm">
				<label>Formato
					<select id="format">
						<option value="json">Tela</option>
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#picking-waves-report-form',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#pwr-companies', 'companies', { labels: ['nick'] });
			const today = new Date();
			const iso = today.toISOString().slice(0, 10);
			const elFrom = formset.form.node.querySelector('#date_from');
			const elTo = formset.form.node.querySelector('#date_to');
			if (elFrom && !elFrom.value) elFrom.value = iso;
			if (elTo && !elTo.value) elTo.value = iso;
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from' }, types: [types.pubsub()] },
		{ properties: { selector: '#date_to' }, types: [types.pubsub()] },
		{ properties: { selector: '#view' }, types: [types.pubsub()] },
		{ properties: { selector: '#wave_id' }, types: [types.pubsub()] },
		{ properties: { selector: '#status' }, types: [types.pubsub()] },
		{ properties: { selector: '#format' }, types: [types.pubsub()] },
	],

};
